<template>
  <div>
    <b-overlay :show="getIsLoading" rounded="sm">
      <b-navbar
        style="background-color: white; height: 90px; padding-top: 1.3rem"
      >
        <b-navbar-nav>
          <template>
            <h5 class="mt-auto mb-auto ml-4">
              {{ $i18n.t('container.agency') }}:
            </h5>
            <b-nav-item-dropdown
              :text="currentTenantLongName"
              variant="primary"
              class="m-2 tenants-dropdown"
            >
              <b-dropdown-item
                v-for="tenant in tenantsOptions"
                :key="tenant.value.name"
                :active="currentTenantName === tenant.value.name"
                @click.prevent="onTenantSelectorChange(tenant.value)"
                >{{ tenant.value.longName }}</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </template>
          <template v-if="!($router.currentRoute.name === 'TechnicalAlarm')">
            <h5 class="mt-auto mb-auto ml-4">
              {{ $i18n.t('container.residence') }}:
            </h5>
            <b-nav-item-dropdown
              v-if="softTenants.length && selectedSoftTenant"
              :text="selectedSoftTenant._source.model"
              variant="primary"
              class="m-2 tenants-dropdown"
            >
              <b-dropdown-item
                v-for="tenant in softTenantsOptions"
                :key="tenant._source.model"
                :active="
                  selectedSoftTenant._source.model === tenant._source.model
                "
                @click.prevent="onSoftTenantSelectorChange(tenant)"
                >{{ tenant._source.model }}</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </template>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown>
            <template #button-content>
              <span>{{ currentUsername }}</span>
            </template>
            <b-dropdown-item :href="accountURL" target="_blank">{{
              $i18n.t('container.profile')
            }}</b-dropdown-item>
            <b-dropdown-item href="#" @click="logout">{{
              $i18n.t('container.logout')
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
      <SideBar />
      <div class="main-container">
        <router-view></router-view>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { isActionAllowed } from '@/helpers/rights.js';
import SideBar from '@/components/sidebar/SideBar.vue';
import { keycloak } from '../config.json';

export default {
  name: 'DefaultContainer',
  components: {
    SideBar,
  },
  data() {
    return {
      userRights: [],
      accountURL: new URL(
        'account',
        keycloak.clientConfig.authority
      ).toString(),
    };
  },
  computed: {
    ...mapGetters('app', ['getIsLoading']),
    ...mapGetters('auth', [
      'currentUsername',
      'currentUserRights',
      'currentUser',
    ]),
    ...mapGetters('tenants', [
      'tenants',
      'softTenants',
      'selectedTenant',
      'currentTenantName',
      'currentTenantLongName',
      'selectedSoftTenant',
    ]),
    canFetchTenantList() {
      return isActionAllowed(
        this.currentUserRights,
        'multi-tenancy/tenant',
        'list'
      );
    },
    tenantsOptions() {
      return this.tenants.map((tenant) => ({
        value: tenant,
        text: `${tenant.name} (${tenant.group})`,
      }));
    },
    softTenantsOptions() {
      return this.softTenants;
    },
  },

  mounted() {},

  methods: {
    ...mapActions('tenants', ['FETCH_TENANT_LIST', 'FETCH_USER_TENANTS']),
    ...mapMutations('tenants', [
      'SET_SOFT_TENANTS',
      'SET_SELECTED_TENANT',
      'SET_SELECTED_SOFT_TENANT',
    ]),
    async logout() {
      await this.$store.dispatch('auth/LOG_OUT', {
        kuzzle: this.$kuzzle,
        visitorId: this.$store.state.app.visitorId,
      });

      await this.$parent.$data.userManager.signoutRedirect();
    },
    onTenantSelectorChange(tenant) {
      this.SET_SELECTED_TENANT(tenant);
    },
    onSoftTenantSelectorChange(tenant) {
      this.SET_SELECTED_SOFT_TENANT(tenant);
    },
    showErrorToast(message) {
      this.$bvToast.toast(message, {
        title: 'Sorry, an error has occurred.',
        variant: 'danger',
        toaster: 'b-toaster-bottom-right',
        appendToast: true,
        dismissible: true,
        noAutoHide: true,
      });
    },
  },

  watch: {
    selectedTenant: {
      immediate: true,
      async handler(val) {
        if (!val) {
          return;
        }
        this.$log.debug('Tenant set: fetching alerts and subscribing...');

        const assetsRes = await this.$kuzzle.query({
          index: val.index,
          controller: 'device-manager/asset',
          action: 'search',
          body: {
            // query: {
            //   equals: {
            //     type: 'residence',
            //   },
            // },
            sort: {
              reference: 'asc',
            },
          },
          size: 100,
          lang: 'koncorde',
        });
        if (assetsRes.result.total) {
          await this.SET_SOFT_TENANTS(assetsRes.result.hits);
          await this.SET_SELECTED_SOFT_TENANT(assetsRes.result.hits[0]);
        } else {
          await this.SET_SOFT_TENANTS([]);
          await this.SET_SELECTED_SOFT_TENANT({
            _source: {},
          });
        }
      },
    },
  },
};
</script>

<style lang="scss">
body {
  overflow: hidden;
}

.navbar {
  background-color: $gray-100;
  border-bottom: 1px solid $gray-300;
  height: $navbar-height;
  padding-left: $sidebar-width;
}

.main-container {
  height: calc(100vh - #{$navbar-height});
  overflow-y: auto;
}

.tenants-dropdown span {
  color: $danger;
}
</style>
